import format from 'date-fns/format'
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
export const optionalPhoneRegex = /^(?:(?![\s\S])|(\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*))$/
export const appVersion = process.env.REACT_APP_VERSION ||  "0.1.1"
export const apiURLs = {
    payment: {
        url: (process.env.REACT_APP_API_ROOT).toString().trim() + 'calculator/calculate/payment'
    },
    affordability: {
        url: (process.env.REACT_APP_API_ROOT).toString().trim() + 'calculator/calculate/affordability'
    },
    rate:{
        url: (process.env.REACT_APP_API_ROOT).toString().trim() + 'calculator/product/mortgage/best'
    },
    lead: {
        url: (process.env.REACT_APP_API_ROOT).toString().trim() + 'calculator/lead'
    },
    products: {
        url: (process.env.REACT_APP_API_ROOT).toString().trim() + 'calculator/product'
    }
}

export const getGA = () =>{
    if(window.ga && window.ga.send){
        return window.ga
    }
    if(window.ga && window.ga.getAll){
        return window.ga.getAll()[0] //need to use things such as ga.set and ga.send
    }
    return {}
}

export const focusBlur = async (input, time) => {return new Promise(resolve => setTimeout(()=>{
    if(isIE === "IE"){
        input.focus() 
    }
    else{
        try{
            input.focus({preventScroll: true}); //IE doesn't support this
        }
        catch{
            input.focus(); //Fallback for safari? and apparently other mobile phones (samsung)
                           //https://wpt.fyi/results/html/interaction/focus/processing-model/preventScroll.html?label=master&product=chrome%5Bstable%5D&product=edge%5Bstable%5D&product=firefox%5Bexperimental%5D&product=safari%5Bexperimental%5D&aligned
        }
    }
    return resolve(true)}, time))
}

export function sleep(time) { //Just testing not really needed
    return new Promise((resolve) => setTimeout(resolve, time));
}

export const isIE = () =>{ //: "IE"  | "notIE" bool wasn't working for some reason
    const ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE '); //Keeping this in case we need to return the version number at some point. Not supporting ie10 and below at all but the app might work.
    if (msie > 0) {
        // IE 10 or older => return
        return "IE"
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return
        return "IE"
    }
    return "notIE"
}

export const isInViewPort= (elem) =>{
    //Requires an element by reference
    const r = elem.getBoundingClientRect()
    const y = document.documentElement.scrollTop || document.body.scrollTop;
    const h = window.innerHeight;
    console.log(r, y, h)
    return (r.top > 0 && r.top < y + h) || (r.bottom > 0 && r.bottom < y + h)
}

export function isMobile(){
    return window.innerWidth < 992
}

export const allFieldsValid = async (formRef,props, time = 35, selector = 'input') =>{
    //TODO: replace this with a less hacky solution
    let timeBuffer = isIE() === "IE" ? 15 : 0
    //IE fix, initially i had the array as reversed but that won't work in ie and chrome for mobile?
    await Promise.all([...formRef.current.querySelectorAll(selector)].map((input)=>{return focusBlur(input, time + timeBuffer)})) //Tricky only allowed to use await in first line of module?
    if((props.infields && props.infields.validationErrors.length === 0) || (props.usrfields && props.usrfields.validationErrors.length === 0)){
        return true;
    }
    const fisrtError = formRef.current.querySelector('.form-field-group.has-error')
    const btn = formRef.current.querySelector('button')
    if(fisrtError && fisrtError.scrollIntoView){
        fisrtError.scrollIntoView() //focus the first error it finds
        fisrtError.focus()          //focus error fallback
    }
    else if(isIE() === "IE" && btn.scrollIntoView){
        btn.scrollIntoView() //If we're in IE {preventScroll: true} will not work so we need to scroll back down to the button
        
    }                        //Another way to tackle this would be to scroll to clientY where the event was triggered, but sadly IE doesn't support scroll
    return false;
}
export const DesTransform = (apiType, infields, usrfields, additionalData) =>{
    /* Affordabilty
        {
            "incomes": [
                { 
                    "annualIncome": "100000",
                    "person": "Bob"
                }
            ],
            "expenses": [
                { 
                    "amount": "0",
                    "expenseType": "Taxes"
                }
            ],
            "downPayment":"200000",
            "annualInterestRate": "0.0219",
            "amortizationPeriod": "300",
            "AmortizationFrequency":"Monthly",
            "compoundingFrequency": "SemiAnnually"
        }

        epenseType: 
        /// <summary> Heating Expenses. </summary>
        Heating,
        /// <summary> Tax Expenses. </summary>
        Taxes,
        /// <summary> All other Expenses. </summary>
        Other
    */
   
   switch(apiType){
       case "affordability":
       const {rate, period, AmortizationFrequency, compoundingFrequency} = additionalData
       return{
            incomes: [
                {
                    annualIncome: infields.annualhousehold,
                    person: usrfields.firstname + " " + usrfields.lastname
                }
            ],
            expenses: ["condofees","monthlyheating","monthlydebt","propertytax"].map((ex)=>{
                let amount = infields[ex];
                let name = ex
                switch(ex){
                    case "condofees":
                        return{
                            amount,
                            expenseType: "CondoFees",
                            name
                        }
                    case "monthlyheating":
                        return{
                            amount,
                            expenseType: "Heating",
                            name
                        }
                    case "monthtlydebt":
                        return{
                            amount,
                            expenseType: "Other",
                            name
                        }
                    case "propertytax":
                        return{
                            amount,
                            expenseType: "Taxes",
                            name
                        }
                    default: 
                        return{
                            amount,
                            expenseType: "Other",
                            name
                        }
                }
            }),
            downPayment: infields.downpayment,
            annualInterestRate: rate, amortizationPeriod: period, AmortizationFrequency, compoundingFrequency
       }
       case "lead":
       //const AffordabilityInput = additionalData.affordability || false; //To generate a lead we need to run DesTransform Twice, once to get the affordability results and then this
        /*
        {
            "FirstName":"Affordibility Test",
            "LastName":"TestLastName",
            "Email":"djensen@comsavings.com",
            "Phone":"604-637-5042",
            "PrivacyPolicyAgreement":"yes",
            "Member":"True",
            "Branch":"Surrey",
            "AffordabilityInput":{
                "incomes": [
                    { 
                        "annualIncome": "70000",
                        "person": "Bob"
                    }
                ],
                "expenses": [
                    { 
                        "amount": "2000",
                        "expenseType": "Taxes"
                    },
                    { 
                        "amount": "40",
                        "expenseType": "Heating"
                    },
                    { 
                        "amount": "250",
                        "expenseType": "CondoFees"
                    },
                    { 
                        "amount": "150",
                        "expenseType": "Other"
                    }
                ],
                "downPayment":"300",
                "annualInterestRate": "0.0219",
                "amortizationPeriod": "300",
                "AmortizationFrequency":"Monthly",
                "compoundingFrequency": "SemiAnnually"
            },
            "Booking":{
                "TimeOfDay": "Any string that works",
                "DesiredDate": "13Feb2021",
                "QA": [
                    {
                        "Q": "Do you want a callback?",
                        "A": "Yes"
                    },
                    {
                        "Q": "Do you prefer Email?",
                        "A": "No, phone please"
                    },
                    {
                        "Q": "When do you prefer to be called?",
                        "A": "Evenings"
                    }
                ]
            }
        }
        */
        //Add our referer question to the questions
        usrfields['qa90'] = {Q: 'RefererBefore', A: window.document.referrer || ''}
        usrfields['qa100'] = {Q: 'Referer', A: window.location.href || '/'}
        //const UTCDate = utcToZonedTime((usrfields.date || addDays(new Date(), 1)), "UTC") //#1726 part of this ticket. need to convert date to UTC
        const UTCDate = usrfields.date || setHours(addDays(new Date(), 1), 10); //Do not convert to UTC for now
        return{
            FirstName: usrfields.firstname,
            LastName: usrfields.lastname,
            Email: usrfields.email,
            Phone: usrfields.phonenumber,
            PrivacyPolicyAgreement: usrfields.terms ? "yes" : "no",
            Member: usrfields.ismember === "Yes" ? "True" : "False",
            Branch: usrfields.branch ? usrfields.branch : "",
            ...(additionalData && additionalData.affordability && {AffordabilityInput: additionalData.affordability}),
            Booking: {
                TimeOfDay: format(UTCDate,"HH:mm:ss"), //Part of #1725 calcualtions will not have a desired date / time by default
                DesiredDate: format(UTCDate,"yyyy-MM-dd"),
                QA: Object.keys(usrfields).filter(key=>key.substr(0,2) === "qa").reduce((pv,cv)=>{
                    return pv.concat(usrfields[cv])
                },[])
            }
        }
       default:
           return
   }
}